<template>
  <el-dialog
    class="dialogShareMessage"
    top="10vh"
    v-if="showMessageShare"
    width="750px"
    :visible.sync="showMessageShare"
    @close="closeDialog"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    append-to-body>
    <div
      slot="title"
      class="d-flex align-items-center justify-content-between py-3 px-12">
      <span class="fw-700 text-grey900 font-16">Chuyển tiếp tin nhắn</span>
      <el-popover
        placement="bottom"
        trigger="click">
        <div class="conversation-box-popover">
          <div class="d-flex align-items-center flex-grow-1 my-1">
            <div
              class="radio-button"
              :class="tagType === 0 && 'radio-button-active'"
              @click="changeTagOpt(0)">
              <span>Tất cả ({{ getTagCount(0) }})</span>
            </div>
            <div
              class="radio-button"
              :class="tagType === 1 && 'radio-button-active'"
              @click="changeTagOpt(1)">
              <span>Thẻ chỉ định ({{ getTagCount(1) }})</span>
            </div>
            <div
              class="radio-button"
              :class="tagType === 2 && 'radio-button-active'"
              @click="changeTagOpt(2)">
              <span>Thẻ thường ({{ getTagCount(2) }})</span>
            </div>
          </div>
          <el-input
            class="ms-1"
            placeholder="Tìm kiếm thẻ đã tạo"
            v-model="searchTagName"
            size="small"></el-input>
          <div
            class="d-flex flex-wrap text-center overflow-auto mt-2 px-1"
            style="max-width: 500px; max-height: 400px; min-width: 500px">
            <div
              v-for="(item, index) in listTagView"
              :key="index">
              <div
                class="d-flex pointer"
                @click="addOrRemoveTag(item)">
                <TagV2
                  :data="item"
                  :inactive="!isSelected(item)"
                  :item="item"
                  :selected="isSelected(item)"
                  :is-button="true" />
              </div>
            </div>
          </div>
        </div>

        <el-tooltip
          slot="reference"
          effect="dark"
          content="Lọc theo tag"
          placement="top">
          <el-button
            size="small"
            class="d-flex text-blue500 me-5">
            <div class="d-flex">
              <span>Lọc theo thẻ đã gắn ({{ selectedTags.length }})</span>
              <IconV2
                name="v2-arrow1_drop_down"
                color="#1769D7" />
            </div>
          </el-button>
        </el-tooltip>
      </el-popover>
    </div>
    <el-divider class="my-0 mb-1" />
    <div style="z-index: 999">
      <div>
        <div class="d-flex align-items-center justify-content-between mb-1 px-2">
          <div class="d-flex align-items-center flex-grow-1 mt-1">
            <div
              class="radio-button"
              :class="conversationType === 'all' && 'radio-button-active'"
              @click="changeConversationType('all')">
              <span>Tất cả</span>
            </div>
            <div
              class="radio-button"
              :class="conversationType === 'personal' && 'radio-button-active'"
              @click="changeConversationType('personal')">
              <span>Cá nhân</span>
            </div>
            <div
              class="radio-button"
              :class="conversationType === 'group' && 'radio-button-active'"
              @click="changeConversationType('group')">
              <span>Nhóm</span>
            </div>
          </div>

          <el-input
            ref="input"
            style="width: 220px"
            placeholder="Tìm kiếm"
            size="small"
            clearable
            v-model="searchKey"
            @input="searchKeyChanged()"
            prefix-icon="el-icon-search"></el-input>

          <el-select
            class="ms-2"
            style="width: 150px"
            placeholder="Sắp xếp theo"
            size="small"
            v-model="sortOption"
            @input="searchKeyChanged()"
            prefix-icon="el-icon-search">
            <el-option
              label="A - Z"
              key="toName"
              value="toName"></el-option>
            <el-option
              label="Liên hệ gần đây"
              key="lastMessageTime"
              value="lastMessageTime"></el-option>
          </el-select>
        </div>

        <!-- <div
          id="tag-container"
          style="padding: 5px; border: 1px solid #e0e4e8; border-radius: 10px; max-height: 64px; overflow: auto">
          <span
            v-for="item in app.tags"
            class="me-2"
            :key="item.id"
            @click="addOrRemoveTag(item)">
            <TagCustom
              :item="item"
              :selected="isSelected(item)"
              :is-button="true" />
          </span>
        </div> -->

        <div class="divider-custom-zalo"></div>
        <div class="d-flex">
          <div
            style="flex: 1"
            class="border-right">
            <div
              class="add-share-popup-left"
              style="flex: 1">
              <div
                v-for="(itemGroup, index) in groupViews"
                :key="index">
                <div class="font-14 text-grey600 py-1 px-12 border-bottom border-top bg-base-milk d-flex justify-content-between">
                  <span class="fw-700">
                    {{ itemGroup[0].swName ? itemGroup[0].swName.charAt(0).toUpperCase() : itemGroup[0].toName.charAt(0).toUpperCase() }}
                  </span>
                  <span>{{ itemGroup.length }}</span>
                </div>
                <div
                  class="select-item rounded-2"
                  v-for="item in itemGroup"
                  :key="item.id">
                  <div
                    class="d-flex py-2 pointer align-items-center"
                    @click.stop.prevent="selectItem(item)">
                    <el-checkbox
                      class="ms-3"
                      :value="checkSelectedContact(item.id)"></el-checkbox>

                    <el-image
                      :src="item.avatar"
                      style="border-radius: 1000px"
                      class="mx-2 mb-1 img-select">
                      <div
                        slot="error"
                        class="image-slot">
                        <el-image
                          src="/assets/images/no-avatar.png"
                          style="border-radius: 1000px"
                          class="img-select"></el-image>
                      </div>
                    </el-image>
                    <div class="d-flex flex-column justify-content-between">
                      <div
                        style="white-space: normal"
                        class="flex-1 font-size-14 text-1-line text-grey900 fw-700">
                        {{ item.toName }}
                        <span
                          v-if="item.swName"
                          class="font-14 text-grey600 fw-400">
                          | {{ item.swName }}
                        </span>
                      </div>
                      <ListTagEllipsis
                        v-if="item.tags.length"
                        class="ms-0 mt-1 mb-0"
                        :tags="item.tags || []" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-start bg-base-milk border-bottom border-top py-2 ms-2 mt-1">
              <span style="width: 85px">Hiển thị: 20</span>
              <el-pagination
                style="width: 200px; font-weight: 400 !important"
                small
                background
                layout="prev, pager, next"
                :current-page="pageInfo.page"
                :total="pageInfo.total"
                :page-size="pageInfo.pageSize"
                @current-change="currentSwPageChanged"
                @prev-click="pageInfo.page -= 1"
                @next-click="pageInfo.page += 1"></el-pagination>
            </div>
          </div>
          <div
            class="position-absolute ms-2 mt-1"
            v-bind:style="conversationsSelected.length === 0 ? 'right:-50% ' : 'position:static !important'"
            :class="conversationsSelected.length > 0 ? 'left-group' : 'left-group no-item'">
            <div
              class="font-size-14 fw-semibold mb-1 d-flex align-items-center justify-content-between"
              style="width: 335px">
              <div style="color: #081c36">
                Tài khoản đã chọn
                <span class="ms-1 font-size-14">({{ conversationsSelected.length }}/{{ LIMIT }})</span>
              </div>
              <div
                class="me-3 pointer"
                @click="removeAllConversations">
                <IconV2
                  name="v2-delete_sweep"
                  size="20px" />
              </div>
            </div>
            <div
              class="add-share-popup-right"
              style="overflow-y: auto; overflow-x: hidden">
              <div
                class="mt-2 me-2 rounded-2 d-flex align-items-center justify-content-between"
                style="background-color: rgba(225, 237, 253, 0.6); color: #42444d; width: 320px; border: thin solid #c2dcff"
                v-for="item in conversationsSelected"
                :key="item.id">
                <div
                  class="position-relative rounded-2 d-flex pointer d-flex align-items-center flex-grow-1 py-1"
                  @click.stop.prevent="unSelect(item.id)">
                  <!-- <el-avatar :src="item.avatar" class="ms-1 me-2 img-selected" />-->
                  <el-image
                    :src="item.avatar"
                    style="border-radius: 1000px"
                    class="ms-1 me-2 img-selected">
                    <div
                      slot="error"
                      class="image-slot">
                      <el-image
                        src="/assets/images/no-avatar.png"
                        style="border-radius: 1000px"
                        class="img-selected"></el-image>
                    </div>
                  </el-image>
                  <div>
                    <div
                      style="white-space: normal"
                      class="text-1-line font-size-14 text-break me-1">
                      <span>{{ item.toName }}</span>
                    </div>
                    <div
                      style="white-space: normal"
                      class="text-1-line font-13 text-grey600 text-break me-1">
                      <span>{{ item.swName }}</span>
                    </div>
                  </div>
                </div>
                <div
                  class="me-2 pointer"
                  @click.stop.prevent="unSelect(item.id)">
                  <IconV2 name="v2-close" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="px-2">
          <div
            class="d-flex mt-1 pointer mb-1"
            v-if="shareContactCard ? true : false">
            <div class="mx-1 align-self-center">[Danh thiếp]</div>
          </div>
          <div
            class=""
            v-else>
            <div
              class="bg-blue100 rounded-2 border d-flex pointer justify-content-between mb-1 px-2 pb-2 pt-1 mt-2"
              v-if="isPhoto || isVideo || isCardBusiness(message) || isFile || message.isArray">
              <div
                v-if="isFile"
                class="border rounded-2 pb-1 px-1"
                style="background-color: white">
                <ChatFileV3
                  :file="message"
                  :account-id="conversation.accountId"
                  :message-id="message.id"
                  :preventDownload="true" />
              </div>
              <img
                v-else-if="!message.isArray && !groupImages.length"
                :src="getThumbUrl()"
                class="rounded-1 mt-1 img-thumb" />
              <div
                v-if="groupImages.length > 0"
                class="mx-1 pt-1 d-flex flex-grow-1 justify-content-between align-items-center font-14 fw-500 text-blue400">
                <div class="d-flex">
                  <img
                    v-for="(img, idx) in groupImagesContent.filter((item, index) => index < 5)"
                    :key="idx"
                    :src="img"
                    class="rounded-1 img-thumb me-2" />
                  <div
                    v-if="groupImagesContent.length > 5"
                    class="rounded-1 img-thumb d-flex align-items-center justify-content-center"
                    style="background-color: #dcdfe9">
                    {{ groupImagesContent.length - 5 }}+
                  </div>
                </div>
                <span>{{ groupImages.length }} ảnh được chọn</span>
              </div>
              <div
                v-if="isCardBusiness(message)"
                class="mx-1 align-self-center">
                [Danh thiếp]
              </div>
              <div
                v-if="message.isArray"
                class="mx-1 d-flex flex-grow-1 align-items-center justify-content-between">
                <div
                  v-if="message.type === 'media'"
                  class="d-flex">
                  <img
                    v-for="(img, idx) in getMultiMessageContent.filter((item, index) => index < 5)"
                    :key="idx"
                    :src="img"
                    class="rounded-1 img-thumb me-2" />
                  <div
                    v-if="getMultiMessageContent.length > 5"
                    class="rounded-1 img-thumb d-flex align-items-center justify-content-center"
                    style="background-color: #dcdfe9">
                    {{ getMultiMessageContent.length - 5 }}+
                  </div>
                </div>
                <div
                  v-if="message.type === 'share.file'"
                  class="d-flex">
                  <div
                    class="border rounded-2 pb-1 px-1"
                    style="background-color: white">
                    <ChatFileV3
                      :file="message.messages[0]"
                      :account-id="conversation.accountId"
                      :message-id="message.messages[0].id"
                      :preventDownload="true" />
                  </div>
                  <div
                    v-for="(file, index) in message.messages.filter((item, i) => i > 0)"
                    :key="index"
                    class="border pb-1"
                    style="background-color: white; width: 10px; border-top-right-radius: 5px; border-bottom-right-radius: 5px"></div>
                </div>
                <span class="font-14 fw-500 text-blue400">{{ message.messages.length }} {{ message.type === "media" ? "ảnh" : "tệp" }} được chọn</span>
              </div>
            </div>
          </div>
          <el-input
            class="mt-2"
            type="textarea"
            rows="2"
            placeholder="Thêm mô tả"
            :autosize="{ minRows: 2, maxRows: 3 }"
            v-model="messageContent"></el-input>
        </div>

        <div class="d-flex justify-content-end px-12 py-2">
          <span
            class="edit-button font-size-16 me-3 fw-semibold rounded-2 pointer py-2 px-3"
            @click="closeDialog()">
            Hủy
          </span>
          <!--      <span class="share-button font-size-16 fw-semibold rounded-2 pointer py-2 px-3" @click="send()">Chia sẻ</span>-->
          <el-button
            :disabled="isDisable"
            class="share-button font-size-16 fw-semibold rounded-2 pointer py-2 px-3"
            :loading="isDisable"
            @click="send">
            Hoàn thành
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
/* eslint-disable */
import TagCustom from "../common/TagCustom";
import { COMMON } from "../../lib/Common";
import { groupByName } from "../../lib/text-utils";
import ListTagEllipsis from "../ListTagEllipsis.vue";
import ChatFileV3 from "./ChatFileV3.vue";
import TagV2 from "../TagV2.vue";
import { removeVietnameseTones } from "../../lib/text-utils";

export default {
  props: ["showMessageShare", "message", "conversation", "messageList", "accountId", "shareContactCard"],
  components: { TagCustom, ListTagEllipsis, ChatFileV3, TagV2 },
  data() {
    return {
      isDisable: false,
      pageInfo: {
        page: 1,
        pageSize: 20,
        total: 0,
      },
      searchKey: "",
      sortOption: "toName",
      conversations: [],
      conversationsSelected: [],
      selectedTags: [],
      views: [],
      groupViews: [],
      LIMIT: 100,
      messageContent: "",
      photoContent: {},
      groupLayoutId: "",
      groupImages: [],
      conversationType: "all",
      tagType: 0,
      searchTagName: "",
    };
  },
  computed: {
    isFile() {
      return this.message.msgType === COMMON.CHAT_FILE;
    },
    isText() {
      return this.message.msgType === "webchat";
    },
    isPhoto() {
      return this.message.msgType === "chat.photo";
    },
    isVideo() {
      return this.message.msgType === COMMON.CHAT_VIDEO;
    },
    getMultiMessageContent() {
      return this.message.messages.map((item) => {
        // return this.getCloudUrl(JSON.parse(item.content).href, item);
        return JSON.parse(item.content).href;
      });
    },
    groupImagesContent() {
      return this.groupImages.map((item) => {
        // return this.getCloudUrl(JSON.parse(item.content).href, item);
        return JSON.parse(item.content).href;
      });
    },
    listTagView() {
      let view = [];
      switch (this.tagType) {
        case 0: {
          view = this.app.tags;
          break;
        }
        case 1: {
          view = this.app.tags.filter((p) => p.assign);
          break;
        }
        case 2: {
          view = this.app.tags.filter((p) => !p.assign);
          break;
        }
      }

      if (this.searchTagName) {
        view = view.filter(
          (tag) =>
            removeVietnameseTones(tag.name.toLowerCase()).includes(this.searchTagName.toLowerCase()) ||
            tag.name.toLowerCase().includes(this.searchTagName.toLowerCase())
        );
      }

      return view;
    },
  },
  watch: {
    selectedTags: function () {
      this.search();
    },
  },
  methods: {
    getTagCount(valueOption) {
      switch (valueOption) {
        case 0: {
          return this.app.tags.length;
        }
        case 2: {
          return this.app.tags.filter((t) => !t.assign).length;
        }
        case 1: {
          return this.app.tags.filter((t) => t.assign).length;
        }
        default:
          return 0;
      }
    },
    changeTagOpt(tagType) {
      this.tagType = tagType;
      // switch (tagType) {
      //   case 0: {
      //     break;
      //   }
      //   case 1: {
      //     break;
      //   }
      //   case 2: {
      //     break;
      //   }
      //   default:
      //     break;
      // }
    },
    getThumbUrl() {
      if (this.isFile && Object.keys(this.photoContent).length > 1) {
        return this.fileTypeIcon(this.photoContent.extension);
      }
      let data = this.photoContent.thumbUrl;
      return data;
    },
    searchKeyChanged() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.getContact(true);
      }, 300);
    },
    getMsgType() {
      if (this.isText) {
        return 1;
      } else if (this.isPhoto) {
        return 2;
      } else if (this.isVideo) {
        return 5;
      } else if (this.isCardBusiness(this.message)) {
        return 6;
      } else if (this.isFile) {
        return 19;
      }
    },
    getMessage() {
      if (this.isText) {
        return this.messageContent;
      } else if (this.isPhoto) {
        this.photoContent.title = this.messageContent;
        return JSON.stringify(this.photoContent);
      } else if (this.isVideo) {
        return JSON.stringify(this.photoContent);
      } else if (this.isCardBusiness(this.message)) {
        delete this.photoContent.thumbUrl;
        return JSON.stringify(this.photoContent);
      } else if (this.isFile) {
        return JSON.stringify(this.photoContent);
      }
    },
    send() {
      if (this.shareContactCard) {
        return this.onSendContactCard();
      }

      let request = {
        accountId: this.accountId,
        toIds: this.conversationsSelected.filter((s) => s.group !== true).map((s) => s.toId),
        toGroupIds: this.conversationsSelected.filter((s) => s.group === true).map((s) => s.toId),
      };
      if (request.toIds.length === 0 && request.toGroupIds.length === 0) return this.alertError("Bạn chưa chọn cuộc trò chuyện");

      if (this.message.isArray) {
        if (this.message.type === COMMON.CHAT_FILE) {
          this.message.messages.forEach((s) => {
            const newRequest = {
              ...request,
              message: JSON.stringify(this.getFileParams(s)),
              msgType: 19,
            };
            this.isDisable = true;
            this.sendShareMessage(newRequest);
          });
          return;
        } else {
          this.message.messages.forEach((s) => {
            const newRequest = {
              ...request,
              message: JSON.stringify(this.getPhotoParams(s)),
              msgType: 2,
            };
            this.sendShareMessage(newRequest);
          });
          return;
        }
      }

      if (this.groupLayoutId === "") {
        request = {
          ...request,
          message: this.getMessage(),
          msgType: this.getMsgType(),
        };
        if (this.isText && this.getMessage().trim().length === 0) return this.alertError("Vui lòng nhập nội dung tin nhắn");
        this.isDisable = true;
        this.sendShareMessage(request);
      } else {
        this.isDisable = true;
        this.groupImages.forEach((s) => {
          request = {
            ...request,
            message: JSON.stringify({ ...this.getPhotoParams(s), groupLayoutId: new Date().getTime() }),
            msgType: 2,
          };
          this.sendShareMessage(request);
        });
      }

      if ((this.groupLayoutId || this.isVideo || this.isCardBusiness(this.message) || this.isFile) && this.messageContent) {
        request = {
          ...request,
          message: this.messageContent,
          msgType: 1,
        };
        if (this.isText && this.getMessage().trim().length === 0) return this.alertError("Vui lòng nhập nội dung tin nhắn");
        this.isDisable = true;
        setTimeout(() => {
          this.sendShareMessage(request);
        }, 200);
      }
    },

    async onSendContactCard() {
      await Promise.all(
        this.conversationsSelected.map(async (conv) => {
          await this.$http.post("/api/message/sendContact", {
            accountId: this.shareContactCard.accountId,
            friendId: `${this.shareContactCard.accountId}_${this.shareContactCard.friendId}_0_0`,
            toId: conv.toId,
            conversationId: conv.id,
          });
          this.alert("success", "Chia sẻ tin nhắn thành công");
        })
      );
      this.closeDialog();
    },

    sendShareMessage(request) {
      this.$http
        .post("/api/message/forwardMessage", request)
        .then(() => {
          this.alert("success", "Chia sẻ tin nhắn thành công");
        })
        .finally(() => this.closeDialog());
    },
    closeDialog() {
      this.$emit("closeSharePopup");
    },
    search() {
      this.views = this.conversations
        .filter((s) => {
          if (s.toName === null) return;
          if (s.swName) {
            let isExist = s.swName.toLowerCase().trim().includes(this.searchKey.toLowerCase().trim());
            if (isExist) return true;
          }
          return s.toName.toLowerCase().trim().includes(this.searchKey.toLowerCase().trim());
        })
        .filter((s) => {
          if (this.selectedTags.length === 0) return true;
          else return s.tags.map((s) => s.id).some((t) => this.selectedTags.includes(t));
        });
    },

    addOrRemoveTag(tag) {
      const index = this.selectedTags.indexOf(tag.id);
      if (index > -1) {
        this.selectedTags.splice(index, 1);
      } else {
        this.selectedTags.push(tag.id);
      }
      this.getContact(true);
    },

    isSelected(tag) {
      let index = this.selectedTags.indexOf(tag.id);
      return index > -1;
    },
    checkSelectedContact(id) {
      return this.conversationsSelected.findIndex((con) => con.id === id) !== -1;
    },
    selectItem(item) {
      if (this.conversationsSelected.length > this.LIMIT) return;
      let filter = this.conversationsSelected.filter((con) => con.id === item.id);
      if (filter != null && filter.length > 0) {
        const index = this.conversationsSelected.indexOf(filter[0]);
        if (index > -1) {
          this.conversationsSelected.splice(index, 1);
        }
      } else {
        this.conversationsSelected.push(item);
      }
    },
    unSelect(id) {
      let filter = this.conversationsSelected.filter((con) => con.id === id);
      if (filter != null && filter.length > 0) {
        const index = this.conversationsSelected.indexOf(filter[0]);
        if (index > -1) {
          this.conversationsSelected.splice(index, 1);
        }
      }
    },
    removeAllConversations() {
      this.conversationsSelected = [];
    },
    currentSwPageChanged(newPage) {
      this.pageInfo.page = newPage;
      this.getContact();
    },
    changeConversationType(type) {
      this.conversationType = type;
      this.getContact();
    },
    getContact(search = false) {
      if (search) {
        this.pageInfo.page = 1;
      }
      let body = {
        accountId: this.accountId,
        searchKey: this.searchKey,
        selectedTags: this.selectedTags.length > 0 ? this.selectedTags : null,
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        type: this.conversationType,
        sortOption: this.sortOption
      };
      this.$http.post("/api/conversation/all", body).then((rep) => {
        this.pageInfo.total = rep.data.totalElements;
        this.views = rep.data.content;
        console.log(this.conversation.toId);
        this.views = this.views.filter((c) => c.toId != this.conversation.accountId);
        if (this.app.allGroupIds.has(body.accountId)) {
          let allGroupIds = this.app.allGroupIds.get(body.accountId);
          this.views = this.views.filter((s) => {
            if (s.group === true) {
              return !!allGroupIds.includes(s.toId);
            } else return true;
          });
        }
        this.groupViews = groupByName(this.views, "swName", "toName");
      });
    },
    getPhotoParams(item) {
      let photo = JSON.parse(item.content);
      let params = JSON.parse(photo.params);
      let data = {};
      data.title = photo.title;
      data.oriUrl = photo.href;
      data.thumbUrl = photo.thumb;
      data.hdUrl = params.hd;
      data.width = params.width;
      data.height = params.height;
      data.properties = null;
      data.normalUrl = photo.href;
      if (this.isPhotoGroup(item)) {
        data.totalItemInGroup = params.total_item_in_group;
        data.idInGroup = params.id_in_group;
        data.isGroupLayout = params.is_group_layout;
        data.groupLayoutId = params.group_layout_id;
      }
      return data;
    },
    isActionText() {
      try {
        let con = JSON.parse(this.message.content);
        if (["msginfo.actionlist", "rtf"].includes(con.action)) {
          return true;
        }
      } catch (e) {
        return false;
      }
    },
    getVideoParams(message) {
      let content = JSON.parse(message.content);
      let params = JSON.parse(content.params);
      let item = {};
      item.videoUrl = content.href;
      item.thumbUrl = content.thumb;
      item.duration = params.duration;
      item.width = params.video_width;
      item.height = params.video_height;
      item.fileSize = params.fileSize;
      item.properties = null;
      return item;
    },
    getCardBusiness(message) {
      let content = JSON.parse(message.content);
      let uid = content.params;
      let item = {};
      item.contactUid = uid;
      let description = JSON.parse(content.description);
      item.qrCodeUrl = description.qrCodeUrl;
      if (description.phone) {
        item.phone = description.phone;
      }
      item.thumbUrl = content.thumb;
      return item;
    },
    getPhotoList() {
      this.messageList
        .filter((p) => p.msgType == "chat.photo")
        .forEach((item) => {
          let params = JSON.parse(JSON.parse(item.content).params);
          if (params.is_group_layout) {
            if (params.group_layout_id == this.groupLayoutId && item.type != "timeline") {
              console.log("item", item);
              const existImg = this.groupImages.find((i) => i.id === item.id || i.idInGroup == params.id_in_group);
              if (!existImg) {
                this.groupImages.push({ ...item, idInGroup: params.id_in_group });
              }
            }
          }
        });
    },
    getPhoto(photos, item) {
      let params = JSON.parse(JSON.parse(item.content).params);
      if (params.is_group_layout) {
        if (params.group_layout_id == this.groupLayoutId) {
          photos.push({ id: params.id_in_group, url: this.findUrlHDIfExist(item.content) });
        }
      }
    },
    getFileParams(message) {
      let content = JSON.parse(message.content);
      let msgInfo = {};
      msgInfo.url = content.href;
      msgInfo.fileName = content.title;
      let params = JSON.parse(content.params);
      msgInfo.extension = params.fileExt;
      msgInfo.checksum = params.checksum;
      msgInfo.fdata = params.fdata;
      msgInfo.fType = params.fType;
      msgInfo.size = params.fileSize;
      return msgInfo;
    },
  },
  mounted() {
    if (this.message.msgType === "webchat") {
      this.messageContent = this.isActionText() ? JSON.parse(this.message.content).title : this.message.content;
    } else if (this.message.msgType === "chat.photo") {
      this.photoContent = this.getPhotoParams(this.message);
      this.messageContent = this.photoContent.title;
      if (this.isPhotoGroup(this.message)) {
        if (JSON.parse(this.message.content).params) {
          let params = JSON.parse(JSON.parse(this.message.content).params);
          if (params.is_group_layout) {
            this.groupLayoutId = params.group_layout_id;
          }
        }
        this.getPhotoList();
      }
    } else if (this.isVideo) {
      this.photoContent = this.getVideoParams(this.message);
    } else if (this.isCardBusiness(this.message)) {
      this.photoContent = this.getCardBusiness(this.message);
    } else if (this.isFile) {
      this.photoContent = this.getFileParams(this.message);
    }
    // this.$refs.input.focus();
    this.getContact();
  },
};
</script>

<style lang="scss">
.dialogShareMessage {
  .el-dialog__body {
    padding: 0 !important;
  }
  .el-dialog__header {
    padding: 0 !important;
  }

  .share-button:hover {
    background-color: #0a58c0;
  }

  .share-button {
    color: #fff;
    background-color: #0068ff;
  }

  .edit-button:hover {
    background-color: #b6bec9;
  }

  .edit-button {
    background-color: #eaedf0;
    /*margin-left: auto;*/
  }

  /*.select-item{*/
  /*  border-radius: 5px;*/
  /*}*/
  .select-item:hover {
    background-color: #f1f4f8;
  }

  .img-selected {
    border: 1px solid #fff;
    width: 36px;
    height: 36px;
    min-width: 36px;
    min-height: 36px;
  }

  .img-select {
    width: 48px;
    height: 48px;
    min-width: 48px;
    min-height: 48px;
  }

  // label {
  //   background-color: #fff;
  //   border: 3px solid #ccc;
  //   border-radius: 50%;
  //   cursor: pointer;
  //   min-height: 21px;
  //   left: 0;
  //   position: relative;
  //   top: 50%;
  //   max-width: 21px;
  //   min-width: 21px;
  //   max-height: 21px;
  // }

  // label:after {
  //   border: 2px solid #fff;
  //   border-top: none;
  //   border-right: none;
  //   content: "";
  //   height: 6px;
  //   left: 3px;
  //   opacity: 0;
  //   position: absolute;
  //   top: 4px;
  //   transform: rotate(-45deg);
  //   width: 10px;
  // }

  .left-group:after {
    overflow: hidden;
  }

  .left-group {
    width: 335px;
    transition: width 0.4s;
    overflow: hidden;
    margin-bottom: 16px;

    /*float: right;*/
    /*background-color: #f1f4f8;*/
    /*!*width: 100px;*!*/
    /*height: 100%;*/
    /*animation: animateThis 0.2s cubic-bezier(0.42, 0, 1, 1);*/
    /*animation-fill-mode: forwards;*/
  }

  .no-item {
    visibility: hidden;
    width: 0;
    max-width: 0;
  }

  .img-thumb {
    max-width: 50px;
    max-height: 50px;
    min-width: 50px;
    min-height: 50px;
    object-fit: cover;
  }

  @keyframes animateThis {
    0% {
      width: 0;
      height: 100%;
    }
    100% {
      width: 100%;
      height: 100%;
    }
  }

  .add-share-popup-left {
    height: 346px;
    overflow-y: auto;
  }

  .add-share-popup-right {
    height: 322px;
    width: 320px;
    overflow-y: auto;
  }

  #tag-container::-webkit-scrollbar {
    display: none;
  }
}
</style>